module.exports = __webpack_public_path__ + "img/subtitle-btn-icon.7524c323.svg";